<template>
  <!-- <div class="user-modal-wrapper"> -->
  <div class="user-modal">
    <form>
      <section class="row">
        <!-- USERNAME -->
        <div class="row-field">
          <label for="userModalUsername" class="input-label">{{ $t('username') }}</label>
          <div class="input-wrapper" :class="{ 'invalid': !isUsernameValid }">
            <span class="tms">B</span>
            <input id="userModalUsername" type="text" :placeholder="$t('username')" v-model="user.username"
              @keyup="isUsernameValid = true, formatUsername()" :disabled="limitedFunctionality" autocomplete="false" />
            <span v-if="limitedFunctionality" class="disabled">A</span>
          </div>
        </div>

        <!-- NAME -->
        <div class="row-field">
          <label for="userModalName" class="input-label">{{ $t('name') }}</label>
          <div class="input-wrapper" :class="{ 'invalid': !isNameValid }">
            <span class="tms">B</span>
            <input id="userModalName" type="text" :placeholder="$t('name')" v-model="user.name"
              @keyup="isNameValid = true, formatName()" />
          </div>
        </div>
      </section>

      <section class="row">
        <!-- EMAIL -->
        <div class="row-field">
          <label for="userModalEmail" class="input-label">E-mail</label>
          <div class="input-wrapper" :class="{ 'invalid': !isEmailValid }">
            <span class="tms2">G</span>
            <input id="userModalEmail" placeholder="E-mail" v-model="user.email" @keyup="isEmailValid = true" />
          </div>

        </div>
        <!-- PASSWORD -->
        <div class="row-field">
          <label for="userModalPassword" class="input-label">{{ $t('password') }}</label>
          <div class="input-wrapper" :class="{ 'invalid': !isPasswordValid }">
            <span class="tms">A</span>
            <input id="userModalPassword" type="password" :placeholder="$t('password')" v-model="user.password"
              @keyup="isPasswordValid = true" autocomplete="false" />
          </div>
        </div>
      </section>

      <hr>

      <section class="row">
        <!-- POSITION -->
        <div class="row-field" v-if="!limitedFunctionality">
          <label for="userModalPosition" class="input-label">{{ $t('position') }}</label>
          <div class="input-wrapper">
            <span class="tms2">Q</span>
            <input id="userModalPosition" type="text" :placeholder="$t('position')" v-model="user.position" />
          </div>
        </div>
        <!-- PHONE -->
        <div class="row-field">
          <label for="userModalPhone" class="input-label">{{ $t('phone') }}</label>
          <div class="input-wrapper">
            <span class="tms2">v</span>
            <input id="userModalPhone" :placeholder="$t('phone')" v-model="user.phone" />
          </div>
        </div>
      </section>
        <!-- COEFFICIENT -->
        <div class="row-field">
          <label for="userModalCoefficient" class="input-label">{{ $t('coefficient') }}</label>
          <div class="input-wrapper" :class="{ 'invalid': !isCoefficientValid }">
            <span class="tms">B</span>
            <input id="userModalCoefficient" @keyup="isCoefficientValid = true"
             :placeholder="$t('coefficient')" v-model="user.coefficient" />
          </div>
        </div>

      <hr>

      <!-- GROUP -->
      <section class="row">
        <div class="row-field" v-if="user.group">
          <label for="userGroupName" class="input-label">{{ $t('group') }}</label>
          <div class="new-input">
            <span class="tms2">D</span>
            <!-- NOT SELECTED -->
            <input id="userGroupName" v-if="!user.group._id" type="text" :placeholder="$t('group')"
              @focus="getGroups(), openDropdown(1)" @blur="closeDropdown(1)" v-model="searchGroups" />
            <!-- SELECTED -->
            <input v-else id="userGroupName" type="text" :placeholder="$t('group-name')"
              @focus="getGroups(), openDropdown(1)" v-model="user.group.name" @blur="closeDropdown(1)"
              :disabled="user.group._id" />
            <span v-if="user.group._id" class="clear" @click="resetSelectedGroup()">F</span>
            <span v-else class="arrow" :class="{ 'arrow-reversed': openedDropdown[1] }">K</span>
          </div>
          <!-- DROP-DOWN COMPANIES -->
          <div class="new-input-dropdown" :class="{ 'new-input-dropdown-active': openedDropdown[1] }">
            <ul v-if="groups.length">
              <li v-for="g in filteredGroups" :key="g._id" @mousedown="selectGroup(g)">{{ g.name }}</li>
              <li class="no-results" v-if="searchGroups && !filteredGroups.length">
                {{ $t('no-group') }}.
                <br />{{ $t('pre-added-groups') }}
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section class="add-wrapper" v-if="!limitedFunctionality" @click="isGroupModalOpened = true">
        <span class="tms">t</span>
        <p>Добави вътрешна ВАС група</p>
      </section>

      <hr>
      <template v-if="!limitedFunctionality">
        <section class="row">
          <!-- PERMISSIONS -->
          <div class="row-field">
            <label class="input-label" :class="{'input-label--invalid': !isPermissionsValid}">{{ $t('permissions-tms') }}</label>
            <div class="user-modal-permissions">
              <Checkbox v-if="getUser.permissions.isSuperAdmin" v-model="user.permissions.isSuperAdmin" :label="$t('users-superadmin')"/>
              <Checkbox v-model="user.permissions.isAdmin" :label="$t('users-admin')"/>
              <Checkbox v-model="user.permissions.isLeader" :label="$t('leader')" @input="toggleIsLeaderRole(user)"/>
              <Checkbox v-model="user.permissions.isReporter" :label="$t('reporter')"/>
              <Checkbox v-model="user.permissions.isEmployee" :label="$t('employee')"/>
            </div>
          </div>
        </section>
        <section class="row">
          <!-- PERMISSIONS INVOICES -->
          <div class="row-field">
            <label class="input-label" :class="{'input-label--invalid': !isPermissionsValid}">{{ $t('permissions-invoices') }}</label>
            <div class="user-modal-permissions">
              <Checkbox v-model="user.permissions.canUploadInvoice" :label="$t('users-can-upload-invoices')"/>
              <Checkbox v-model="user.permissions.canApproveInvoice" :label="$t('users-can-approve-invoices')"/>
            </div>
          </div>
        </section>
      </template>

      <hr v-if="!limitedFunctionality">


      <div class="user-modal-actions">
        <div class="switch-container" v-if="!limitedFunctionality">
          <label class="switch">
            <input type="checkbox" v-model="user.isActive" />
            <span class="slider"></span>
          </label>
          <label v-if="user.isActive">{{ $t('active-single') }}</label>
          <label v-else>{{ $t('inactive-single') }}</label>
        </div>
        <div v-else>
          <!-- JUST AND EMPTY DIV FOR THE SPACE-BETWEEN RULE TO WORK -->
        </div>
        <div class="btns">
          <button v-if="!idToEdit" class="btn btn-new" type="submit" value="Submit" @click.prevent="register">
            <!-- <span class="tms">B</span> -->
            {{ $t('save') }}
          </button>
          <button v-else class="btn btn-new" type="submit" value="Submit" @click.prevent="edit">
            <!-- <span class="tms">B</span> -->
            {{ $t('save') }}
          </button>
          <!-- <button class="btn btn-close" @click.prevent="closeModal(false)">
              <span class="tms">F</span>
              {{ $t('cancel') }}
            </button> -->
        </div>
      </div>
    </form>
    <transition name="fade">
      <UserGroupModal v-if="isGroupModalOpened" @close="closeGroupModal()" />
    </transition>
  </div>
  <!-- </div> -->
</template>

<script>
import UserGroupModal from './UserGroupModal';
import Checkbox from './Checkbox.vue';
import { mapGetters } from 'vuex';
import log from '../mixins/log.js';
export default {
  mixins: [log],
  props: ['idToEdit', 'limitedFunctionality'],
  components: {
    UserGroupModal,
    Checkbox
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUser'
      // ...
    ]),
    filteredGroups() {
      return this.groups.filter(g => {
        return g.name.toLowerCase().includes(this.searchGroups.toLowerCase());
      });
    }
  },
  data() {
    return {
      isGroupModalOpened: false,
      openedDropdown: [false, false],
      selectCompany: false,
      isUsernameValid: true,
      isPasswordValid: true,
      isNameValid: true,
      isEmailValid: true,
      isCoefficientValid: true,
      isPermissionsValid: true,
      searchGroups: '',
      groups: [],
      user: {
        username: '',
        password: '',
        email: '',
        name: '',
        position: '',
        phone: '',
        company: '',
        coefficient: 1,
        isActive: true,
        leave: {},
        group: { _id: '' },
        permissions: {
          isSuperAdmin: false,
          isAdmin: false,
          isReporter: true,
          isWorker: false,
          isEmployee: false,
          // isCEO: false,
          // isHR: false,
          // isTechLead: false
        }
      }
    };
  },
  methods: {
    toggleIsLeaderRole(u) {
      let url = `${process.env.VUE_APP_BASE_URI}/company/active?reporterId=${u._id}&isObjectLeader=true`;

      this.$http.get(url).then((res) => {
        if (res.data.length && !u.permissions.isLeader) {
          this.$snotify.warning(
            `${u.name} е рък в един или повече обекти, не може да му се премахне роля рък. обект`
          );
          this.$set(u.permissions, "isLeader", true);
        } 
      });
    },
    initLeave() {
      const year = new Date().getFullYear();
      for (let i = 0; i < 4; i++) {
        this.$set(this.user.leave, year - i, 0);
      }
    },
    getSpecificUser(id) {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/${id}`)
        .then(response => {
          this.user = response.data;
          if (!this.user.leave) {
            this.user.leave = {};
            this.initLeave();
          }
        });
    },
    getGroups() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group?active=true`)
        .then(response => {
          this.groups = response.data;
        });
    },
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);

        if (this.searchGroups && !this.user.group._id) {
          this.$snotify.warning('Трябва да изберете групата');
        }

        this.searchGroups = '';
      }, 100);
    },
    resetSelectedGroup() {
      this.user.group = { _id: '' };
    },
    selectGroup(g) {
      this.user.group = g;
    },
    // chooseCompany(c) {
    //   this.$set(this.user, 'company', c);
    // },
    // clearCompany() {
    //   this.$set(this.user, 'company', null);
    // },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateUsername(username) {
      if (!username.length) {
        return false;
      }
      const re = /^[a-z0-9_.-]*$/;
      if (!username.match(re)) {
        return false;
      }
      return true;
    },
    // Reformat username - only lowercase latin letters, numbers, dot, underscore and dash
    formatUsername() {
      this.user.username = this.user.username
        .replace(/[^A-Za-z0-9-._]/g, '')
        .toLowerCase();
    },
    // Reformat username - only lowercase latin letters, numbers, dot, underscore and dash
    formatName() {
      this.user.name = this.user.name.replace(/[^А-Яа-я0-9 -._]/g, '');
    },
    checkForm() {
      if (!this.validateUsername(this.user.username)) {
        this.isUsernameValid = false;
      }
      if (!this.user.password && !this.idToEdit) {
        this.isPasswordValid = false;
      }

      if (!this.user.name) {
        this.isNameValid = false;
      }
      if (this.user.email) {
        if (this.user.email.length && !this.validateEmail(this.user.email)) {
          this.isEmailValid = false;
        }
      }
      if(!this.user.coefficient || isNaN(this.user.coefficient)) this.isCoefficientValid = false;
      if (!Object.values(this.user.permissions).filter((p) => p === true).length) {
        this.isPermissionsValid = false;
      }

      // If everything is valid
      if (
        this.isUsernameValid &&
        this.isPasswordValid &&
        this.isNameValid &&
        this.isEmailValid &&
        this.isCoefficientValid &&
        this.isPermissionsValid 
      ) {
        return true;
      }
      // if not
      return false;
    },
    async updateGroups() {
      const promises = [];
      for (let g of this.groups) {
        promises.push(
          await new Promise((resolve) => {
            this.$http
              .get(`${process.env.VUE_APP_BASE_URI}/group/users/${g._id}`)
              .then(async (res) => {
                g.users = res.data;

                await new Promise((resolve) => {
                  this.$http
                    .put(`${process.env.VUE_APP_BASE_URI}/group`, g)
                    .then(() => {
                      resolve();
                    })
                    .catch((err) => {
                      this.error = err.response.data.message;
                    });
                });
                resolve();
              })
              .catch((err) => {
                this.error = err.response.data.message;
              });
          })
        );
      }
      if (promises.length) {
        Promise.all(promises)
          .then(() => { })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    register() {
      if (this.checkForm()) {
        let userForRequest = this.user;
        // if (!userForRequest.email.length) {
        //   delete userForRequest.email;
        // }
        this.$http
          .post(`${process.env.VUE_APP_BASE_URI}/auth/register`, userForRequest)
          .then(() => {
            this.$snotify.success(this.$t('success-new-user'));
            this.newLog('newUser', this.user.username);
            this.closeModal(true);
            this.updateGroups()
          })
          .catch(error => {
            console.log(error.response);
            this.$snotify.error(this.$t('something-went-wrong'));
          })
          .then(() => { });
      } else {
        // TODO: Do something
      }
    },
    edit() {
      if (this.checkForm()) {

        this.$http
          .put(
            `${process.env.VUE_APP_BASE_URI}/auth/users/${this.idToEdit}`,
            this.user
          )
          .then(res => {
            this.$snotify.success(this.$t('success-changes'));
            // IF THE CURRENTLY LOGGED USER CHANGED HIS OWN ROLE IT LOGGES HIM OUT
            if (this.idToEdit === this.$store.state.user._id) {
              const oldPermissions = this.$store.state.user.permissions;
              const newPermissions = res.data.user.permissions;
              if (
                !(
                  oldPermissions.isSuperAdmin === newPermissions.isSuperAdmin &&
                  oldPermissions.isAdmin === newPermissions.isAdmin &&
                  oldPermissions.isReporter === newPermissions.isReporter &&
                  oldPermissions.isWorker === newPermissions.isWorker &&
                  oldPermissions.isEmployee === newPermissions.isEmployee &&
                  this.$store.state.user.isActive === res.data.user.isActive
                )
              ) {
                this.$store
                  .dispatch('logout')
                  .then(() => this.$router.push('/login'))
                  .catch(err => console.log(err));
              }
            }
            this.newLog('editUser', this.user.username);
            this.closeModal(true);
            this.updateGroups()
          })
          .catch(error => {
            console.log(error.response);
            this.$snotify.error(this.$t('something-went-wrong'));
          })
          .then(() => { });
      } else {
        // TODO: Do something
      }
    },
    closeGroupModal() {
      this.isGroupModalOpened = false;
      setTimeout(() => {
        if (this.idToEdit) this.getSpecificUser(this.idToEdit)
      }, 100);
    },
    closeModal(isEdited) {
      // isEdited = true => means something is changed
      // isEdited = false => just close the modal
      this.$emit('closeUserModal', { isEdited: isEdited });
    }
  },
  mounted() {
    this.initLeave();
    this.getGroups()
    document.body.classList.add("no-scroll");

    if (this.idToEdit) {
      this.getSpecificUser(this.idToEdit);
    } else {
      // if (this.userMode) {
      this.user.permissions = {
        isSuperAdmin: false,
        isAdmin: false,
        isReporter: false,
        isWorker: false,
        isEmployee: true,
      };
      // } else {
      //   this.user.permissions = {
      //     isSuperAdmin: false,
      //     isAdmin: false,
      //     isReporter: false,
      //     isWorker: true
      //   };
      // }
    }

    if (this.idToEdit === this.$store.state.user._id) {
      if (this.limitedFunctionality) {
        this.$snotify.warning(this.$t('logout-warning-1'));
      } else {
        this.$snotify.warning(this.$t('logout-warning-2'));
      }
    }

    this.$eventBus.$on('closeModalFromSpeechRecognition', () => {
      this.closeModal();
    });
  },
  destroyed() {
    document.body.classList.remove("no-scroll");
    this.$eventBus.$off('closeModalFromSpeechRecognition');
  }
};
</script>
